import { render, staticRenderFns } from "./creatGoodDetails.vue?vue&type=template&id=6925bc7e&scoped=true"
import script from "./creatGoodDetails.vue?vue&type=script&lang=js"
export * from "./creatGoodDetails.vue?vue&type=script&lang=js"
import style0 from "./creatGoodDetails.vue?vue&type=style&index=0&id=6925bc7e&prod&lang=less"
import style1 from "./creatGoodDetails.vue?vue&type=style&index=1&id=6925bc7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6925bc7e",
  null
  
)

export default component.exports